export const CAMEL_LETTERS = [
  ['e', 'r', 't', 'y', 'u', 'ı', 'o', 'p', 'ğ', 'ü'],
  ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', 'ş', 'i'],
  ['DELETE', 'z', 'c', 'v', 'b', 'n', 'm', 'ö', 'ç', 'ENTER'],
];

export const GUESS_COUNT = 7;
